import { apiClient } from "../config";

async function changeProgramStatus(id: any, status: any) {
  const url = `/admin/programs/${id}/status`;
  const res = await apiClient.put(url, null, { params: { status } });
  return res.data;
}

export default changeProgramStatus;
